import { $ } from '../../../shared/js/utils/dom';
import Bus from '../../../shared/js/modules/event-bus';

const overlay = $('.overlay');
let overlayModifier = '';
const init = () => {
  Bus.subscribe('navmain_open', 'OverlayActivate', show);
  Bus.subscribe('navmain_close', 'OverlayDeactivate', hide);
  Bus.subscribe('header-quicklinks_open', 'OverlayActivate', show);
  Bus.subscribe('header-quicklinks_close', 'OverlayDeactivate', hide);
  overlay.addEventListener('click', hide);
};
const show = e => {
  const body = document.body;
  overlay.classList.add('overlay--is-active');
  body.classList.add('overlay-active');
  overlayModifier = e?.overlayModifier || '';
  if (overlayModifier) overlay.classList.add(`overlay--${overlayModifier}`);
  if (overlayModifier) body.classList.add(`overlay-active--${overlayModifier}`);
  Bus.broadcast('overlay_show', null);
};
const hide = e => {
  // If a modifier is in use, only that modifier or a click on the overlay are able to hide the overlay.
  if (!!overlayModifier && e?.overlayModifier !== overlayModifier && !e?.type)
    return;
  const body = document.body;
  overlay.classList.remove('overlay--is-active');
  body.classList.remove('overlay-active');
  if (overlayModifier) overlay.classList.remove(`overlay--${overlayModifier}`);
  if (overlayModifier)
    body.classList.remove(`overlay-active--${overlayModifier}`);
  Bus.broadcast('overlay_hide', null);
};

if (overlay) init();
